var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({
      position: 'relative',
      background:
        _vm.index == 0
          ? 'transparent'
          : _vm.impactProtectorColor,
      width: '100%',
      height: _vm.mmToEm(_vm.sector.beam.height)
    })}),(_vm.index > 0)?_c('div',{staticStyle:{"position":"relative"}},[_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(0),
        width: _vm.mmToEm(40),
        top: _vm.mmToEm(-_vm.sector.beam.height - 55),
        height: _vm.mmToEm(240),
        borderTopLeftRadius: _vm.mmToEm(40),
        borderBottomLeftRadius: _vm.mmToEm(40),
        background: _vm.beamColor,
        zIndex: 1001
      })}),_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(_vm.sector.beam.length + 20),
        width: _vm.mmToEm(40),
        top: _vm.mmToEm(-_vm.sector.beam.height - 55),
        height: _vm.mmToEm(240),
        borderTopRightRadius: _vm.mmToEm(40),
        borderBottomRightRadius: _vm.mmToEm(40),
        background: _vm.beamColor,
        zIndex: 1001
      })})]):_vm._e(),_c('div',{staticClass:"pallet-level",style:({
      left: _vm.mmToEm(30),
      width: _vm.mmToEm(_vm.sector.beam.length)
    })},[_vm._l((_vm.sector.beam.pallets),function(pallet){return [_c('div',{key:`${_vm.index}:${pallet}`,staticClass:"pallet-level-pallet",style:({
          borderSize: 'border-box',
          width: _vm.mmToEm(800),
          marginTop: _vm.mmToEm(-_vm.levelDistance + 100),
          height: _vm.mmToEm(_vm.levelDistance - (_vm.sector.beam.height + 200)),
          backgroundColor: '#fce2c9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        })},[_c('div',{style:({
            position: 'absolute',
            left: 0,
            top: _vm.mmToEm(_vm.levelDistance - (_vm.sector.beam.height + 250)),
            backgroundColor: '#cea47d',
            height: _vm.mmToEm(50),
            width: _vm.mmToEm(800),
            zIndex: '1001'
          })}),_c('div',{style:({
            position: 'absolute',
            left: 0,
            top: _vm.mmToEm(_vm.levelDistance - (_vm.sector.beam.height + 200)),
            backgroundColor: '#cea47d',
            height: _vm.mmToEm(100),
            width: _vm.mmToEm(100),
            zIndex: '1001'
          })}),_c('div',{style:({
            position: 'absolute',
            left: _vm.mmToEm(325),
            top: _vm.mmToEm(_vm.levelDistance - (_vm.sector.beam.height + 200)),
            backgroundColor: '#cea47d',
            height: _vm.mmToEm(100),
            width: _vm.mmToEm(150),
            zIndex: '1001'
          })}),_c('div',{style:({
            position: 'absolute',
            left: _vm.mmToEm(700),
            top: _vm.mmToEm(_vm.levelDistance - (_vm.sector.beam.height + 200)),
            backgroundColor: '#cea47d',
            height: _vm.mmToEm(100),
            width: _vm.mmToEm(100),
            zIndex: '1001'
          })}),_c('div',{style:({
            fontSize: '0.17em',
            display: 'flex',
            justifyContent: 'center',
            lineHeight: 1,
            textAlign: 'center',
            zIndex: '1001'
          })},[(_vm.index)?_c('div',[(_vm.loadCapacityPerPosition === _vm.sector.beam.loadCapacity)?[_c('div',{staticStyle:{"wrap-mode":"nowrap"},attrs:{"data-cy":"allowed-load-capacity"}},[_vm._v("\n                "+_vm._s(_vm.loadCapacityPerPosition)+" kg\n              ")])]:[_c('div',{staticStyle:{"wrap-mode":"nowrap"},attrs:{"data-cy":"allowed-load-capacity"}},[_vm._v("\n                "+_vm._s(_vm.loadCapacityPerPosition)+" kg\n              ")]),_c('div',{staticStyle:{"opacity":"0.5","font-size":"0.8em","text-decoration":"line-through"},attrs:{"data-cy":"max-load-capacity"}},[_vm._v("\n                "+_vm._s(_vm.sector.beam.loadCapacity)+" kg\n              ")])]],2):_c('div',[_vm._v("\n            Golvplats\n          ")])])])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }